module.exports = __webpack_public_path__ + "static/media/MacroVideo_200.2291314d.jpg";